module.exports = __webpack_public_path__ + "static/media/signin.1217b8ee.svg";